<template>
  <div class="device-detector">
    <!-- 这是一个功能性组件，不渲染任何内容 -->
  </div>
</template>

<script>
import { isMobile } from '@/utils/mobile';
import { getDeviceType, DeviceType, performRedirect } from '@/utils/deviceRedirect';
import { updatePageMeta } from '@/utils/meta';

export default {
  name: 'DeviceDetector',
  data() {
    return {
      deviceType: null,
      checkInterval: null
    };
  },
  created() {
    // 初始检测设备类型
    this.detectDevice();
    
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
    
    // 设置定期检查，以防设备旋转或其他变化
    this.checkInterval = setInterval(this.checkDeviceChange, 2000);
  },
  beforeDestroy() {
    // 清理事件监听和定时器
    window.removeEventListener('resize', this.handleResize);
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  },
  methods: {
    detectDevice() {
      const newDeviceType = getDeviceType();
      
      // 如果设备类型发生变化，记录并检查是否需要重定向
      if (this.deviceType !== newDeviceType) {
        this.deviceType = newDeviceType;
        // 更新页面元数据
        updatePageMeta(newDeviceType);
        // 检查是否需要重定向
        this.checkRedirect();
      }
    },
    handleResize() {
      // 窗口大小变化时检测设备类型
      this.detectDevice();
    },
    checkDeviceChange() {
      // 定期检查设备类型是否变化
      this.detectDevice();
    },
    checkRedirect() {
      // 检查当前路由是否需要重定向
      const currentRoute = this.$route;
      performRedirect(currentRoute);
    }
  }
};
</script>

<style scoped>
.device-detector {
  display: none;
}
</style>